export class LkpExpenssesModel{
  expcode = '' ;
  expname = '' ;
  expnotes = '' ;
  compcode = '' ;
  userid = '' ;
  modifieddate = '2022-01-01' ;

}
